import React from 'react'
import { ChevronRightIcon } from 'src/editor/shared/icons/chevron-right-icon'
import { twMerge } from 'tailwind-merge'

interface SettingsMenuButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: () => React.ReactNode
}

export const SettingsMenuButton = ({
  children,
  className,
  icon,
  ...props
}: SettingsMenuButtonProps) => {
  return (
    <button
      type="button"
      className={twMerge(
        'flex min-h-9 w-full cursor-pointer items-center justify-between rounded-md px-0.5 py-2',
        'transition-all duration-150 hover:bg-btnGhostPrimaryHover active:bg-btnGhostPrimaryPressed',
        className,
      )}
      {...props}
    >
      <span className="text-M">{children}</span>
      {icon ? icon() : <ChevronRightIcon className="h-4 w-4" />}
    </button>
  )
}
